export default theme => ({
  disk_container: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  data: {
    marginTop: theme.sizes[3],
  },
  disk_status_container:{
    display: 'flex',
    alignItems: 'center'
  },
  disk__status: {
    color: theme.palette.primary.dark,
    border: `1px solid ${theme.palette.primary.dark}`,
    float: "right",
    marginTop: 10,
    marginRight: 5,
  },
  deleted: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
  },
  deleted__text: {
    color: `${theme.palette.secondary.main}`,
    fontWeight: "normal !important",
    fontSize: "inherit !important",
  },
  deleted__status: {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
});
